module.exports = __webpack_public_path__ + "static/media/arrowRight.fa96207d.svg";